<template>
	<RouterLink class="block mx-auto w-64" to="/">
		<div class="rounded-full bg-black mx-auto w-40 h-40 shadow-lg border border-white">
			<img class="w-auto h-full mx-auto" src="@/assets/hermes.png" alt="Hermes"/>
		</div>
		<div class="uppercase text-3xl oomph text-center">
			Hermes
		</div>
	</RouterLink>
</template>

<style lang="scss" scoped>
.hermes-logo {
	height: 160px;
	width: 160px;
	text-align: center;
	background: #000;

	img {
		height: 100%;
		width: auto;
	}
}
</style>